// Sama ajatus kuin PlugIcon: yksinkertainen, värin ottaa currentColorista
const EyeIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 28 28" aria-hidden="true">
    {/* perinteinen eye-shape */}
    <path
      fill="currentColor"
      d="M12 4C6.73 4 2.18 7.11 0.5 12c1.68 4.89 6.23 8 11.5 8s9.82-3.11 11.5-8C21.82 7.11 17.27 4 12 4zm0 13a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
    />
  </svg>
);

export default EyeIcon;